import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { Text } from '../text/text.js';
import { colors } from '../../tokens/colors/colors.js';
import '../../tokens/shadows/shadows.js';
import { spacing } from '../../tokens/spacing/spacing.js';
import '../../tokens/breakpoints/breakpoints.js';

function Switch({ label, name, checked, defaultChecked, onChange, onClick, disabled = false, required = false, autoFocus = false, readOnly = false, error, className, }) {
    return (jsxs("div", { children: [jsxs(Label, { className: className, children: [jsx(Input, { type: "checkbox", role: "switch", name: name, checked: checked, defaultChecked: defaultChecked, onChange: (e) => onChange?.(e.target.checked, e), onClick: onClick, disabled: disabled, readOnly: readOnly, autoFocus: autoFocus, required: required, "aria-checked": checked, "aria-disabled": disabled, "aria-required": required, "aria-label": label, "$error": !!error }), jsx(Text, { variant: "subtitle", children: label })] }), error && typeof error === "string" && (jsx(Text, { variant: "bodyS", color: "emergency", textAlign: "left", children: error }))] }));
}
// All values are in pixels
const INPUT_WIDTH = 50;
const INPUT_HEIGHT = 30;
const THUMB_GAP = 2;
const THUMB_WIDTH = INPUT_HEIGHT - THUMB_GAP * 2;
const Label = styled.label `
  display: flex;
  align-items: center;
  gap: ${spacing.S};
`;
const Input = styled.input `
  all: unset;

  position: relative;
  width: ${INPUT_WIDTH}px;
  height: ${INPUT_HEIGHT}px;
  background-color: ${({ $error }) => $error ? colors.systemError : colors.neutralDark2};
  border-radius: 9999px;
  transition: background-color 0.1s ease;
  cursor: pointer;

  &:checked {
    background-color: ${({ $error }) => $error ? colors.systemErrorDark : colors.primary};
  }

  &::after {
    content: "";
    position: absolute;
    display: block;
    top: ${THUMB_GAP}px;
    left: ${THUMB_GAP}px;
    bottom: ${THUMB_GAP}px;
    width: calc(${THUMB_WIDTH}px);
    background-color: ${colors.neutralLight};
    border-radius: 9999px;
    transition: all 0.1s ease;
  }

  &:checked::after {
    left: calc(100% - ${THUMB_GAP}px - ${THUMB_WIDTH}px);
  }

  &:focus-visible {
    outline: 1px dashed ${colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    background-color: ${colors.neutralDark2};
    cursor: auto;
  }

  &:disabled::after {
    background-color: ${colors.neutral};
  }
`;

export { Switch };
